import { onError } from '@apollo/client/link/error'
import { userPermissionGrantsQueryName } from './queries/user-permission-grants'

export const GENERIC_ERROR = 'An error occurred. Please try again.'

function shouldIgnoreGraphqlErrorMessage( operation: { operationName: string }, statusCode?: number ) {
	const ignoreable = [
		operation.operationName === userPermissionGrantsQueryName && statusCode === 403,
		operation.operationName === 'UserPreferences' && statusCode === 404,
		operation.operationName === 'StorePartQuantityCost' && statusCode === 404,
		operation.operationName === 'StorePartDetails' && statusCode === 404,
	]

	return ignoreable.some( ( ignore ) => ignore )
}

export default ( showError: ( key: string, message: string ) => void ) => onError( ( errorData ) => {
	const { operation, graphQLErrors } = errorData
	const networkError: any = errorData.networkError // there's a known type issue within Apollo: https://github.com/apollographql/apollo-link/issues/300#issuecomment-387120102

	let errorMessage
	let statusCode

	if ( networkError ) {
		errorMessage = `NE${networkError.statusCode || '000'}: An error has occurred. Please try again.`
		statusCode = networkError.statusCode

		if ( networkError.statusCode === 401 ) {
			errorMessage = 'You are not logged in. Please log out and log in again.'
		} else if ( networkError.statusCode === 500 && networkError.result && networkError.result.message ) {
			errorMessage = `${networkError.result.message} Please try again shortly.`
		}
	} else if ( graphQLErrors?.length ) {
		const { message, extensions } = graphQLErrors[ 0 ]

		statusCode = extensions ? extensions.status_code : undefined

		if ( statusCode ) {
			switch ( statusCode ) {
				case 403:
					errorMessage = 'You do not have permission to do that.'
					break
				case 404:
					errorMessage = 'Resource not found!'
					break
				case 409:
					errorMessage = message
					break
				default:
					errorMessage = GENERIC_ERROR
			}
		} else {
			errorMessage = message || GENERIC_ERROR
		}
	}

	// Outside the branches so network errors toast too, as they originally did
	if ( errorMessage && !shouldIgnoreGraphqlErrorMessage( operation, statusCode ) ) {
		showError( errorMessage, errorMessage )
	}
} )
